import { useEffect, useRef, useState, useCallback } from "react";
import { ChevronRight, ChevronLeft } from "lucide-react";

export const Swipeable = ({ children, className = "", outerClassName = "", hint = false, testId }) => {
  const ref = useRef(null);
  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(false);

  const check = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    setCanLeft(el.scrollLeft > 4);
    setCanRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  }, []);

  useEffect(() => {
    check();
    const el = ref.current;
    el?.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check);
    const t1 = setTimeout(check, 400);
    const t2 = setTimeout(check, 1200);
    return () => {
      el?.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [check, children]);

  return (
    <div className={`relative ${outerClassName}`} data-testid={testId}>
      <div ref={ref} className={`overflow-x-auto scrollbar-hide ${className}`}>
        {children}
      </div>
      {canLeft && (
        <div className="absolute left-0 top-0 bottom-0 w-10 bg-gradient-to-r from-white via-white/70 to-transparent pointer-events-none z-10 flex items-center justify-start">
          <ChevronLeft className="h-4 w-4 text-[#1B2A4A]" />
        </div>
      )}
      {canRight && (
        <div className="absolute right-0 top-0 bottom-0 w-12 bg-gradient-to-l from-white via-white/70 to-transparent pointer-events-none z-10 flex items-center justify-end">
          <span className="h-6 w-6 rounded-full bg-white shadow-md border border-[#C9D4E6] flex items-center justify-center animate-pulse">
            <ChevronRight className="h-4 w-4 text-[#1B2A4A]" />
          </span>
        </div>
      )}
      {hint && canRight && (
        <div className="sm:hidden absolute -top-1 right-0 -translate-y-full pointer-events-none">
          <span className="text-[10px] font-semibold text-[#1B2A4A] bg-[#EDF1F8] border border-[#C9D4E6] rounded-full px-2 py-0.5">
            Swipe →
          </span>
        </div>
      )}
    </div>
  );
};

export default Swipeable;
